import React, { useState } from 'react';
import {
  Button,
  Chip,
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import Dropzone from './dropzone';
import { setFlag } from 'controllers/flags';
import { resumeParser } from 'controllers/resumeParser/resumeParser';
import FileViewer from 'react-file-viewer';

const useStyles = makeStyles(() => ({
  form: {
    padding: 24,
  },
  formSection: {
    background: '#fff',
    borderRadius: 2,
    marginTop: 24,
  },
  dropZoneContainer: {
    height: 120,
    width: '100%',
    border: '1px dashed #4b8c6f',
  },
  title: {
    opacity: 0.6,
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: 1.31,
    letterSpacing: '0.16px',
    color: '#000000',
    marginBottom: 21,
  },
  btnsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
  },
  btns: {
    width: 144,
    marginRight: 10,
  },
  progress: {
    marginLeft: 8,
  },
  chip: {
    maxWidth: 130,
    marginRight: 7,
  },
  userResume: {
    height: 'auto',
    maxHeight: '45vh',
    overflow: 'scroll',
    border: '2px solid rgb(113 113 113)',
    marginBottom: 15,
    position: 'relative',
    width: '100%',
  },
  userResumeTitle: {
    padding: 9,
    color: 'rgba(255, 255, 255, 0.87)',
    background: 'rgba(0,0,0,0.65)',
    width: 'calc(100% - 18px)',
    zIndex: 1,
    fontSize: 14,
  },
}));

const Form = ({
  setParsedResume,
  parsedResume = null,
  isParsing,
  setIsParsing,
  updateCredits,
}) => {
  const classes = useStyles();
  const [resumeList, setResumeList] = useState([]);

  const handleDrop = async (files = [], errorFiles = []) => {
    if (errorFiles.length) {
      setFlag('ResumeParserFileTypeError', true);
    }

    if (files.length) {
      setResumeList(files);
    } else {
      return false;
    }
  };

  const onReset = () => {
    setResumeList([]);
    setParsedResume(null);
  };

  const onParse = async () => {
    setParsedResume(null);
    setIsParsing(true);

    const response = await resumeParser(resumeList);

    setParsedResume(response);
    setIsParsing(false);
    updateCredits();
  };

  const onDeleteJd = () => {
    setResumeList([]);
  };

  return (
    <Grid item xs={5}>
      <div className={classes.formSection}>
        <div className={classes.form}>
          <Typography classes={{ root: classes.title }}>
            Resume Parser
          </Typography>
          {parsedResume && parsedResume.resumeLink ? (
            <div className={classes.userResume}>
              <div className={classes.userResumeTitle}>
                {parsedResume.filename}
              </div>
              <div>
                <FileViewer
                  fileType={
                    /[.]/.exec(parsedResume.filename)
                      ? /[^.]+$/.exec(parsedResume.filename)[0]
                      : undefined
                  }
                  filePath={parsedResume.resumeLink}
                  onError={(e) => console.log(e)}
                />
              </div>
            </div>
          ) : null}
          <Typography classes={{ root: classes.title }}>
            Upload a Resume (Accepts pdf, doc, docx, jpg, jpeg, png)
          </Typography>
          <Dropzone
            text={'Drag and drop Resume here'}
            handleDrop={handleDrop}
            isLoading={false}
            multiple={false}
            disabled={resumeList.length}
          />
          {resumeList.map(({ name }) => (
            <Chip
              classes={{ root: classes.chip }}
              title={name}
              key={name}
              label={name}
              onDelete={onDeleteJd}
              disabled={isParsing}
              color="default"
              variant="outlined"
            />
          ))}
        </div>
      </div>
      <div className={classes.btnsContainer}>
        <Button
          variant="outlined"
          color="default"
          disabled={(!resumeList.length && !parsedResume) || isParsing}
          classes={{ root: classes.btns }}
          onClick={onReset}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!resumeList.length || isParsing}
          classes={{ root: classes.btns }}
          onClick={onParse}
        >
          Parse
          {isParsing ? (
            <CircularProgress
              size={16}
              color="primary"
              classes={{ root: classes.progress }}
            />
          ) : null}
        </Button>
      </div>
    </Grid>
  );
};

export default Form;
